import {   CanvasModule, CanvasModuleType, PdfItemType } from "@pdf-tools/four-heights-pdf-web-viewer";
import { icons } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/Icon';
import { translationManager } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/TranslationManager';
import { CustomAddShapeAnnotationLayer } from './CustomAddShapeAnnotationLayer';
import { CustomEditShapeAnnotationLayer } from './CustomEditShapeAnnotationLayer';
export class CustomShapeAnnotationModule extends CanvasModule {
  annotationbarElement: HTMLElement | null;
  toolbarElement: HTMLElement | null;
  static moduleInfo = {
    name: 'CustomShapeAnnotationModule',
    moduleType: CanvasModuleType.Tool,
    requiredFeatures: {
      annotate: true,
      fillFormFields: false,
    },
    translationKey: 'annotShape.add',
    icon: 'shapes',
  };
  constructor() {
    super();
    this.annotationbarElement = null;
    this.toolbarElement = null;
    this.name = CustomShapeAnnotationModule.moduleInfo.name;
    this.onEdit = this.onEdit.bind(this);
  }
  onRegister() {
    this.toolbarElement = document.createElement('div');
    return {
      toolbar: this.toolbarElement,
      contextbar: {
        itemTypes: [PdfItemType.LINE,PdfItemType.SQUARE, PdfItemType.CIRCLE],
        icon: icons.edit,
        tooltip: translationManager.getText('annotShape.edit'),
        onCmd: (annotationId: number) => {
          this.onEdit(annotationId);
        },
      },
    };
  }
  activate() {
    if (!this.canvasLayers['add']) {
      this.createCanvasLayer('add', CustomAddShapeAnnotationLayer, PdfItemType.LINE);
    }
    else {
      this.removeCanvasLayer('add');
    }
  }
  onEdit(annotationId: number) {
    this.createCanvasLayer('edit', CustomEditShapeAnnotationLayer, annotationId);
  }
}
